/*
  Kleiner HTTP-Client für /shiftplan_v2.
  Die Auth-Header-Logik bleibt damit an einer Stelle.
*/

import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { getDemoResponse, isDemoMutation } from "../../../demoResponses";
import i18n from "../../../i18n";

const httpClient = axios.create({
  baseURL: API_BASE_URL,
});

httpClient.interceptors.request.use((config) => {
  config.headers = config.headers || {};

  if (isDemoMutation(config)) {
    window.dispatchEvent(new Event("timetab:demo-write-blocked"));
    const message = i18n.t("demo_mode.read_only");
    const error = new Error(message);
    error.code = "ERR_DEMO_READ_ONLY";
    error.config = config;
    error.response = {
      status: 403,
      statusText: "Forbidden",
      data: { error: "demo_read_only", message },
      headers: {},
      config,
    };
    return Promise.reject(error);
  }

  const demoResponse = getDemoResponse(config);
  if (demoResponse) {
    config.adapter = () => Promise.resolve(demoResponse);
  }

  const token = localStorage.getItem("session_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  /*
    Gewählter Standort aus der Topbar — denselben Kopf setzt axiosConfig.js für
    den Rest der Anwendung. Dieser Client hatte ihn nicht, darum blieb der
    Umschalter für /shiftplan wirkungslos: die Seite zeigte immer den primären
    Standort des angemeldeten Nutzers.
  */
  const locationId = localStorage.getItem("selected_location_id");
  if (locationId) {
    config.headers["X-TimeTab-Location-ID"] = locationId;
  }

  return config;
});

export default httpClient;
